import { createSlice } from "@reduxjs/toolkit";
import { fetchClientQbMappings } from "../Thunks/clientQbMappingThunk";
import { addAsyncResourceThunk } from "../helpers/asyncResource";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const clientQbMappingSlice = createSlice({
  name: "clientQbMapping",
  initialState,
  reducers: {
    clearClientQbMappings: (state) => {
      state.data = null;
      state.error = null;
    },
    updateClientQbMapping: (state, action) => {
      const { id, qbClient } = action.payload;
      if (!state.data?.list) return;
      state.data.list = state.data.list.map((row) => (row.id === id ? { ...row, qbClient } : row));
    },
  },
  extraReducers: (builder) => {
    addAsyncResourceThunk(builder, fetchClientQbMappings);
  },
});

export const { clearClientQbMappings, updateClientQbMapping } = clientQbMappingSlice.actions;

export const selectClientQbMappingData = (state) => state.clientQbMapping.data;
export const selectClientQbMappingLoading = (state) => state.clientQbMapping.loading;
export const selectClientQbMappingError = (state) => state.clientQbMapping.error;

export default clientQbMappingSlice.reducer;
